import { Sidebar } from "flowbite-react";

import { useCallback, useEffect, useState } from "react";
import { HiChartPie, HiUsers, HiLogout } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { BsGearFill } from "react-icons/bs";
import { MdHistoryToggleOff } from "react-icons/md";
import { GrCompliance } from "react-icons/gr";
import { dispatch } from "../../../reduxReducers/configureStore";
import { setAuthData } from "../../../reduxReducers/slices/AuthSLice";

const DashboardSidebar = ({
  isDrawr = false,
  setOpenSettings,
  openSettings,
}) => {
  const [currentPage, setCurrentPage] = useState("");

  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    localStorage.removeItem("authToken");
    dispatch(setAuthData(null));
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const newPage = window.location.pathname;

    setCurrentPage(newPage);
  }, [setCurrentPage]);

  return (
    <>
      <Sidebar
        className={isDrawr ? "w-full" : "lg:w-[320px] w-0 lg:block hidden"}
      >
        <div className="flex h-full w-full flex-col gap-2 py-2">
          <Link
            to="/dashboard"
            className={`flex gap-4 p-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg ${
              currentPage.includes("dashboard") && !openSettings
                ? "bg-slate-500 text-white"
                : ""
            }`}
          >
            <HiChartPie className="text-[24px]" />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/interview-upcomming"
            className={`flex gap-4 p-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg ${
              currentPage.includes("interview-upcomming") && !openSettings
                ? "bg-slate-500 text-white"
                : ""
            }`}
          >
            <MdHistoryToggleOff className="text-[24px]" />
            <span>Upcoming Interviews</span>
          </Link>
          <Link
            to="/candidates"
            className={`flex gap-4 p-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg ${
              currentPage.includes("candidates") && !openSettings
                ? "bg-slate-500 text-white"
                : ""
            }`}
          >
            <HiUsers className="text-[24px]" />
            <span>Candidates</span>
          </Link>
          <Link
            to="/interview-completed"
            className={`flex gap-4 p-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg ${
              currentPage.includes("interview-completed") && !openSettings
                ? "bg-slate-500 text-white"
                : ""
            }`}
          >
            <GrCompliance className="text-[24px]" />
            <span>Completed Interviews</span>
          </Link>
          <button
            className={`flex gap-4 p-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg ${
              openSettings ? "bg-slate-500 text-white" : ""
            }`}
            onClick={() => setOpenSettings(true)}
          >
            <BsGearFill className="text-[24px]" />
            <span>Settings</span>
          </button>
          <button
            className="flex gap-4 p-2 mt-auto items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg "
            onClick={handleLogout}
          >
            <HiLogout className="text-[24px]" />
            <span>Logout</span>
          </button>
        </div>
      </Sidebar>
    </>
  );
};

export default DashboardSidebar;
